function getIndexSibling(getNext, index, array) {
    if (getNext) {
        // grab next sibling
        return index === array.length - 1 ? 0 : index + 1;
    }
    // grab previous sibling
    return index === 0 ? array.length - 1 : index - 1;
}

module.exports = getIndexSibling;
